import { createSlice } from "@reduxjs/toolkit";


const initialState = {
    adminlogedin:false,
    userlogedin: false,
    userid:null,
    userdata:{}
}

const auth = createSlice({
    name:'auth',
    initialState,
    reducers: {
        adminlog: (state, action) =>{
           if(action.payload === true){
             state.adminlogedin = true;
           }else{
            state.adminlogedin = false;
           }
        },
        userlog: (state, action)=>{
            if(action.payload === true){
                state.userlogedin = true;
              }else{
               state.userlogedin = false;
              }
        },
        setuserid: (state,action)=>{
            state.userid = action.payload;
        },
        setuserdata: (state,action)=>{
            if(action.payload === true){
                state.userdata = null;
              }else{
               state.userdata = action.payload;
              }
        }
    }
})

export const { adminlog, userlog, setuserid,setuserdata } = auth.actions;
export default auth.reducer;